// @flow
import { withStyle } from 'styletron-react'
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from 'mz-ui-kit/utils'

// Container for the credit card box
export const Container = styled<{
  $active?: boolean,
  $disabled?: boolean,
}>('div', ({ $palette, $active, $disabled }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  width: '100%',
  flexFlow: 'row nowrap',
  alignItems: 'center',
  justifyContent: 'flex-start',
  opacity: $disabled ? '0.5' : '1',
  ...getScreenStyles(
    'xs',
    {
      padding: '10px 5px 10px 5px',
      borderBottom: `1px solid ${$palette('GRAY').lighten(5)}`,
    },
    {
      cursor: $disabled ? 'initial' : 'pointer',
      padding: '15px 10px 15px 10px',
      border: `1px solid ${$palette($active ? 'PRIMARY' : 'GRAY')}`,
      borderRadius: '3px',
      transition: 'border 350ms cubic-bezier(0.165, 0.84, 0.44, 1)',
      ':hover': {
        border: $active
          ? `1px solid ${$palette('PRIMARY')}`
          : `1px solid ${$palette('GRAY').darken(20)}`,
      },
    }
  ),
}))

// Brand icon element
export const BrandContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  marginRight: '15px',
  fontSize: '34px',
  ...getScreenStyles('xs', {
    fontSize: '18px',
  }),
})

export const Label = styled<{
  $alignRight?: boolean,
}>('div', ({ $alignRight }) => ({
  display: 'flex',
  textAlign: $alignRight ? 'right' : 'left',
  flexFlow: 'column nowrap',
  ...getScreenStyles(
    'xs',
    {
      flexFlow: 'row wrap',
      textAlign: 'left',
    },
    {
      flexBasis: '33.33333%',
    }
  ),
}))

export const LabelValue = styled('span', {
  display: 'block',
})

export const ExistingLabel = styled('div', {
  padding: '10px 15px 10px 0',
  fontWeight: 'bold',
  ...getScreenStyles('xs', {
    padding: '5px 5px 5px 0',
  }),
})

export const LabelsWrapper = styled(
  'div',
  getScreenStyles(
    'xs',
    {},
    {
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'space-between',
      flexGrow: 1,
    }
  )
)

export const LabelName = styled('span', {
  fontWeight: 'bold',
  ...getScreenStyles('xs', {
    display: 'none',
  }),
})

export const CardHolderWrapper = withStyle<typeof Label, {}>(
  Label,
  getScreenStyles(
    'xs',
    {
      display: 'none',
    },
    {
      flexBasis: '33.33333%',
    }
  )
)

export const CardExpiryWrapper = styled<{}>('div', ({ $palette }) => ({
  display: 'flex',
  whiteSpace: 'nowrap',
  ...getScreenStyles(
    'xs',
    {
      fontSize: '12px',
      color: `${$palette('gray').darken(20)}`,
    },
    {
      textAlign: 'right',
      flexFlow: 'column nowrap',
      flexBasis: '33.33333%',
    }
  ),
}))
